import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-38" data-mp="2avb9l31mifva">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-39" data-mp="38ap80y11ice3">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-ink bg-cta px-4 py-4 font-display text-base font-black uppercase text-ink shadow-[0_8px_30px_rgba(0,0,0,0.55)] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand sm:text-lg" data-id="element-40" data-mp="333axr5d34snw">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-41" data-mp="2fgb64hjlssy4" />
            <span data-id="element-42" data-mp="2kecrj94i54cr">Get it now for only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}